import { Dispatch } from "redux";

export const SET_SELECTEDACTIVITYFORM = "SET_SELECTEDACTIVITYFORM";
export const SET_PREVIEWACTIVITYFORM = "SET_PREVIEWACTIVITYFORM";
export const SET_ACTIVITYFORM_CHANGES = "SET_ACTIVITYFORM_CHANGES";

export const setActivityFormSelected = (activitySelected: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch({
    type: SET_SELECTEDACTIVITYFORM,
    payload: activitySelected
  });
};

export const setActivityFormPreview = (activitySelected: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch({
    type: SET_PREVIEWACTIVITYFORM,
    payload: activitySelected
  });
};

export const setActivityFormChanges = (sections: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch({
    type: SET_ACTIVITYFORM_CHANGES,
    payload: sections
  });
};
